import * as React from 'react';
import { useState } from 'react';
import { Flex, InputGroup, InputLeftElement, Select, Stack, Text } from "@chakra-ui/react";
import { ContactUsPropTypes } from "./ContactUsPropTypes";
import { Form } from "react-final-form";
import { useRef } from 'react';
import { dropdownConfig, formConfig } from "./config";
import { RenderFormBody } from "./ContactUsFormBody";
import { localisable } from "../../generic/localisable";
import { Icon } from "../../components/icon";
import { CONTACT_US_ICONS, commonInputStyleProps, selectTagProps } from "./constants";
import { RenderFacilityDetails } from "./FacilityDetails";
import GlobalConstants from "../../constants/GlobalConstants";

export const ContactUs = ({ locationsList, locationType, formTitle, variant, iFrameUrl, onLocationChange, onSubmitForm, currentLocation }: ContactUsPropTypes.IContactUsProps) => {

    const formProps = useRef({});
    const { isDarkTheme } = GlobalConstants.getInstance().getConstants();
    const { name: facilityName } = dropdownConfig;
    const [isEmailSent, setIsEmailSent] = useState(false);

    const RenderDropDown = () => {
        return locationType === 'multiLocation' && (<Stack gap='6px'>
            <Text textStyle='body1'>{`${localisable.label}*`}</Text>
            <InputGroup h='36px' w={{ base: '100%', md: '326px' }} alignItems='center' justifyContent='space-between' {...commonInputStyleProps}>
                <InputLeftElement pointerEvents="none" h='34.5px' w='32px' border='none' borderRadius='3px 0 0 3px' bg='background.icon' >
                    <Icon size={'default'} className={CONTACT_US_ICONS['Address']} />
                </InputLeftElement>
                <Select {...selectTagProps} value={currentLocation.id} onChange={onLocationChange} name={facilityName}>
                    {!!locationsList.length && locationsList.map((location: any) => (
                        <option key={location.id} value={location.id} style={{ backgroundColor: `${isDarkTheme ? 'black' : 'white'}` }}>
                            {location.name}
                        </option>
                    ))}
                </Select>
            </InputGroup>
        </Stack>)
    };

    const handleFormSubmit = (values: any, form: any) => {
        onSubmitForm(values, form, setIsEmailSent);
    };

    return (
        <Flex direction='column' color='text.grey' padding={{ base: '16px 8px', sm: '16px', md: '64px' }} mt={'16px'} bg='background.main'>
            <Flex>
                <RenderDropDown />
            </Flex>
            <Flex direction={{ base: 'column', sm: 'row' }} gap='40px'>
                <Flex w={{ base: '100%', md: '612px' }} direction='column' gap='24px'>
                    <Form
                        onSubmit={handleFormSubmit}
                        initialValues={{
                            name: '',
                            phone: '',
                            email: '',
                            subject: '',
                            message: '',
                        }}
                        render={(currentFormProps) => {
                            const { handleSubmit, ...restFormProps } = currentFormProps;
                            formProps.current = restFormProps
                            return (
                                <form onSubmit={handleSubmit}>
                                    <RenderFormBody
                                        formConfig={formConfig()}
                                        formTitle={formTitle}
                                        currentFormProps={currentFormProps}
                                        isEmailSent={isEmailSent}
                                        setIsEmailSent={setIsEmailSent}
                                    />
                                </form>
                            )
                        }}
                    />
                </Flex>
                <Flex w={{ base: '100%', md: '520px' }}>
                    <RenderFacilityDetails
                        iFrameUrl={iFrameUrl}
                        currentLocation={currentLocation}
                        variant={variant}
                    />
                </Flex>
            </Flex>
        </Flex>
    )
};